import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import "datatables.net-dt/css/jquery.dataTables.css";
import $ from "jquery";
import "datatables.net";

function UserList() {
  const navigate = useNavigate();
  const [requestData, setRequestData] = useState([]);
  const [deleteProductId, setDeleteProductId] = useState("");
  const [deleteProductName, setDeleteProductName] = useState("");
  const [dataTable, setDataTable] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    // Initialize DataTable only if it's not initialized yet
    if (!$.fn.dataTable.isDataTable("#users")) {
      const table = $("#users").DataTable({
        serverSide: true, // Enable server-side processing
        processing: true, // Show processing indicator while loading data
        ajax: function (data, callback, settings) {
          const page = settings._iDisplayStart / settings._iDisplayLength + 1; // Get the page number
          const search = data.search.value || ""; // Get the search query
          const length = data.length || ""; // Get the length
          fetchData(page, search, length).then((response) => {
            // Pass data and pagination info to the DataTable callback
            callback({
              draw: response.draw,
              recordsTotal: response.recordsTotal,
              recordsFiltered: response.recordsFiltered,
              data: response.data,
            });
          });
        },
        columns: [
          { data: null, render: (data, type, row, meta) => meta.row + 1 },
          { data: "first_name", render: (data) => `${data}` },
          { data: "email_address", render: (data) => `${data}` },
          {
            data: "verified_status",
            render: (data) => {
              // Ensure data is consistent and normalize it
              const status = String(data).toLowerCase().trim(); // Convert to string, lower case, and remove extra spaces
              return status === "true"
                ? "<span class='badge badge-success'>Active</span>"
                : "<span class='badge badge-warning'>Incomplete</span>";
            },
          },
          {
            data: "created_date",
            render: (data) => new Date(data).toLocaleString(),
          }
        ],
        pageLength: 10, // Display 10 records per page
        lengthMenu: [10, 25, 50, 75, 100], // Allow the user to change the number of rows per page
        responsive: true,
        searching: true, // Enable search functionality
        paging: true, // Enable pagination
      });

      setDataTable(table); // Store DataTable instance
    }

    // Cleanup DataTable when the component is unmounted
    return () => {
      if ($.fn.dataTable.isDataTable("#users")) {
        $("#users").DataTable().clear().destroy();
      }
    };
  }, []); // Empty dependency array to initialize only once

  // Function to fetch data with pagination
  const fetchData = async (page = 1, search = "", length = 10) => {
    try {
      const limit = length; // Limit per page
      const response = await axios.get(
        process.env.REACT_APP_APIURL + "admin/users/list",
        {
          params: {
            limit: limit,
            start: page,
            search_text: search,
          },
        }
      );

      if (response.data.status === "success") {
        setRequestData(response.data.result.users);
        const data = response.data.result;
        const totalUsers = data.pagination.totalUsers; // Get total users count

        return {
          draw: data.draw, // Draw counter for DataTable
          recordsTotal: totalUsers, // Total records (from API)
          recordsFiltered: totalUsers, // Filtered records (can be same if no filters)
          data: data.users, // Data for the current page
        };
      } else {
        console.error("Failed to fetch users:", response.data);
        return {
          draw: 0,
          recordsTotal: 0,
          recordsFiltered: 0,
          data: [],
        };
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      return {
        draw: 0,
        recordsTotal: 0,
        recordsFiltered: 0,
        data: [],
      };
    }
  };

  // Function to delete a user
  const deleteUser = async (productId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}admin/users/delete/`,
        {
          products: productId,
          products_status: "delete",
        }
      );

      if (response.data.status === "success") {
        setRequestData(
          requestData.filter((product) => product._id !== productId)
        );
        $("#modaldelete").modal("hide");
      }
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  // Open delete confirmation modal
  const openDeleteModal = (id, name) => {
    setDeleteProductId(id);
    setDeleteProductName(name);
    $("#modaldelete").modal("show");
  };

  return (
    <div className="wrapper">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">Users</h1>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="table-responsive">
                  <table
                    id="users"
                    className="table table-striped table-bordered txt_lft"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>First Name</th>
                        <th>Email</th>
                        <th>Status</th>
                        <th>Created</th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      {/* Delete Confirmation Modal */}
      <div
        className="modal fade"
        id="modaldelete"
        tabIndex={-1}
        aria-labelledby="modaldeleteLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modaldeleteLabel">
                Delete User
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa-solid fa-xmark" />
              </button>
            </div>
            <div className="modal-body">
              <div className="w-100 d-inline-block text-center">
                Are you sure you want to delete the user
                <br />
                <span className="fwt_600">{deleteProductName}</span>?
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                className="btn btn-primary"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => deleteUser(deleteProductId)}
              >
                Yes, delete
              </button>
              <button
                className="btn btn-secondary"
                data-dismiss="modal"
                aria-label="Close"
              >
                No, cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserList;
